var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPmUnidentified = function SvgPmUnidentified(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.75,
    y: 6.75,
    width: 32.5,
    height: 20.5,
    rx: 3.25,
    fill: "#F7F7FA",
    stroke: "#77819C",
    strokeWidth: 1.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 23H5M9 23h6M1 12h32",
    stroke: "#77819C",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
};
export default SvgPmUnidentified;